import React, { Component } from "react";
import sha256 from "js-sha256";
import axios from "axios";
import { format } from "date-fns";
import LoadingSpinner from "./Spinner";
import ReportGenSectionModal from "../modalPopups/reportGenSection";
import ReportGenNumerologySection from "../modalPopups/reportGenNumerologySection";
import ReportGenZTGSection from "../modalPopups/reportGenZTGSection";
import OverlayLoader from "../modalPopups/overlayLoader";

export default class ReportSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportData: [],
      numerologyReportData: [],
      ztgReportData: [],
      isLoading: false,
      loadingText: "",
      hash: sha256(this.props.searchterm),
      accessToken: localStorage.getItem("accessToken"),
      show: false,
      title: "",
      body: "",
      numerologyShow: false,
      numerologyTitle: "Generate Numerology Reports",
      numerologyBody: "",
      ztgShow: false,
      ztgTitle: "Generate ZTG Reports",
      ztgBody: "",
      overLayPopupShow: false,
      overLayPopupText: "",
    };
  }

  getReportType = (type) => {
    let reportName = "",
      reportLink = "";
    if (type === 13) {
      reportName = "Transit Period Guide";
      reportLink = "https://files.astrologyanswers.com/tpg/";
    } else if (type === 12) {
      reportName = "Personal Discovery";
      reportLink = "https://files.astrologyanswers.com/uploads/";
    } else if (type === 10) {
      reportName = "Essential Year Forecast";
      reportLink = "https://files.astrologyanswers.com/tpg/";
    } else if (type === 11) {
      reportName = "Essential Year Forecast";
      reportLink = "https://files.astrologyanswers.com/year/";
    } else if (type === 7) {
      reportName = "Daily Influence Guide";
      reportLink = "https://files.astrologyanswers.com/year/";
    } else if (type === 9) {
      reportName = "Essential Year Forecast";
      reportLink = "https://files.astrologyanswers.com/year/";
    } else if (type === 4) {
      reportName = "EYF 2015";
      reportLink = "https://files.astrologyanswers.com/eyf2015/";
    } else if (type === 3) {
      reportName = "Personality Profile";
      reportLink = "https://files.astrologyanswers.com/uploads/";
    } else if (type === 6) {
      reportName = "Transit Period Guide";
      reportLink = "https://files.astrologyanswers.com/tpg/";
    } else if (type === 1) {
      reportName = "Life Changing Astrology Guide";
      reportLink = "https://files.astrologyanswers.com/year/";
    } else {
      reportName = "";
      reportLink = "";
    }

    return { reportName, reportLink };
  };

  getNumerologyReportType = (type) => {
    let reportName = "",
      reportLink = "";
    if (type === 2) {
      reportName = "Numerology One Year";
    } else if (type === 1) {
      reportName = "Numerology Life Path	";
    }

    return { reportName, reportLink };
  };

  handleOverylayModalShowClose = (modalStatus, modalText) => {
    this.setState({
      overLayPopupShow: modalStatus,
      overLayPopupText: modalText,
    });
  };

  // Call All Reports
  fetchReportUrl = (URl) => {
    axios
      .get(URl, {
        headers: {
          Authorization: `Bearer ${this.state.accessToken}`,
        },
      })
      .then((result) => {
        this.setState({ isLoading: false });
        this.handleOverylayModalShowClose(false, "");
        //console.log(result);

        var newreportData = [];
        var newnumerologyReportData = [];
        var newztgReportData = [];

        result.data.data.wow.forEach((wowData, i) => {
          newreportData.push(wowData);
        });

        result.data.data.numerologyAuto.forEach((numerologyAutoData, i) => {
          newnumerologyReportData.push(numerologyAutoData);
        });

        result.data.data.ztg.forEach((nztgData, i) => {
          newztgReportData.push(nztgData);
        });

        this.setState({
          reportData: newreportData,
          numerologyReportData: newnumerologyReportData,
          ztgReportData: newztgReportData,
        });
      })
      .catch((error) => {
        // Error
        this.handleOverylayModalShowClose(false, "");
        if (error.response.status === 401) {
          localStorage.clear();
          this.props.navigate("/login");
        }
      });
  };

  handleModalShow = () => {
    this.setState({
      show: true,
      title: "Generate New Report",
      body: "",
    });
  };

  handleModalClose = (fromModal) => {
    this.setState({
      show: false,
    });
  };

  handleNumerologyModalShow = () => {
    this.setState({
      numerologyShow: true,
      numerologyTitle: "Generate Numerology Reports",
      numerologyBody: "",
    });
  };

  handleNumerologyModalClose = (fromModal) => {
    this.setState({
      numerologyShow: false,
    });
  };

  handleZTGModalShow = () => {
    this.setState({
      ztgShow: true,
      ztgTitle: "Generate ZTG Reports",
      ztgBody: "",
    });
  };

  handleZTGModalClose = (fromModal) => {
    this.setState({
      ztgShow: false,
    });
  };

  componentDidMount() {
    this.setState({ isLoading: true });
    this.setState({ loadingText: "Fetching Reports" });
    this.handleOverylayModalShowClose(
      true,
      "Reports Data Loading... Please Wait"
    );
    this.fetchReportUrl(
      `${process.env.REACT_APP_CSAPI_BASE_URL}/member/reports?hash=${this.state.hash}`
    );
  }

  render() {
    return (
      <div className="app-wrapper">
        <div className="app-content pt-3 p-md-3 p-lg-4">
          <div className="container-xl">
            <OverlayLoader
              show={this.state.overLayPopupShow}
              title=""
              body={this.state.overLayPopupText}
            />

            <div className="app-content pt-3 mb-5">
              {this.props.searchterm ? (
                <h3>
                  Search: <code>{this.props.searchterm}</code>
                </h3>
              ) : (
                <h3>There is no name in the query string</h3>
              )}
            </div>

            <div className="row g-3 mb-4 align-items-center justify-content-between">
              <div className="col-auto">
                <h1 className="app-page-title mb-0">Reports</h1>
              </div>
            </div>

            <nav
              id="orders-table-tab"
              className="orders-table-tab app-nav-tabs nav shadow-sm flex-column flex-sm-row mb-4"
            >
              <a
                className="flex-sm-fill text-sm-center nav-link active"
                id="reports-all-tab"
                data-bs-toggle="tab"
                href="#reports-all"
                role="tab"
                aria-controls="reports-all"
                aria-selected="true"
              >
                All
              </a>
              <a
                className="flex-sm-fill text-sm-center nav-link"
                id="reports-numerology-tab"
                data-bs-toggle="tab"
                href="#reports-numerology"
                role="tab"
                aria-controls="reports-numerology"
                aria-selected="false"
              >
                Numerology
              </a>
              <a
                className="flex-sm-fill text-sm-center nav-link"
                id="reports-ztg-tab"
                data-bs-toggle="tab"
                href="#reports-ztg"
                role="tab"
                aria-controls="reports-ztg"
                aria-selected="false"
              >
                ZTG
              </a>
            </nav>

            {this.state.isLoading ? (
              <LoadingSpinner loadingText={this.state.loadingText} />
            ) : (
              ""
            )}

            <div className="tab-content" id="orders-table-tab-content">
              <div
                className="tab-pane fade show active"
                id="reports-all"
                role="tabpanel"
                aria-labelledby="reports-all-tab"
              >
                <div className="app-card app-card-orders-table shadow-sm mb-5">
                  <div className="app-card-body">
                    <div
                      className="table-responsive overflow-auto"
                      style={{ maxHeight: 500 }}
                    >
                      <table className="table table-hover table-bordered border-success">
                        <thead
                          style={{
                            position: "sticky",
                            backgroundColor: "#fff",
                            top: 0,
                          }}
                        >
                          <tr>
                            <th scope="col">Type</th>
                            <th scope="col">Date</th>
                            <th scope="col">Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.reportData.map((reportRecord, i) => {
                            let formattedOrderDate = format(
                              new Date(reportRecord.dateTime),
                              "MMM dd, y h:mm:ss aa"
                            );
                            let reportType = this.getReportType(
                              reportRecord.type
                            ).reportName;

                            let reportLink =
                              reportRecord.report === ""
                                ? "Generating report... Please refresh this page in a minute or two."
                                : this.getReportType(reportRecord.type)
                                    .reportLink + reportRecord.report;
                            let reportHref =
                              reportRecord.report === ""
                                ? "#"
                                : this.getReportType(reportRecord.type)
                                    .reportLink + reportRecord.report;

                            return (
                              <tr key={i}>
                                <td className="fw-bold">{reportType}</td>
                                <td>{formattedOrderDate}</td>
                                <td>
                                  <a
                                    href={reportHref}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-primary"
                                  >
                                    {reportLink}
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="reports-numerology"
                role="tabpanel"
                aria-labelledby="reports-numerology-tab"
              >
                <div className="app-card app-card-orders-table shadow-sm mb-5">
                  <div className="app-card-body">
                    <div
                      className="table-responsive overflow-auto"
                      style={{ maxHeight: 500 }}
                    >
                      <table className="table table-hover table-bordered border-success">
                        <thead
                          style={{
                            position: "sticky",
                            backgroundColor: "#fff",
                            top: 0,
                          }}
                        >
                          <tr>
                            <th scope="col">Type</th>
                            <th scope="col">Date</th>
                            <th scope="col">Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.numerologyReportData.map(
                            (numerologyReportDataRecord, i) => {
                              let formattedOrderDate = format(
                                new Date(numerologyReportDataRecord.dateTime),
                                "MMM dd, y h:mm:ss aa"
                              );
                              let reportType = this.getNumerologyReportType(
                                numerologyReportDataRecord.type
                              ).reportName;
                              let reportLink =
                                this.getNumerologyReportType(
                                  numerologyReportDataRecord.type
                                ).reportLink +
                                numerologyReportDataRecord.report;

                              return (
                                <tr key={i}>
                                  <td className="fw-bold">{reportType}</td>
                                  <td>{formattedOrderDate}</td>
                                  <td>
                                    <a
                                      href={reportLink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="link-primary"
                                    >
                                      {reportLink}
                                    </a>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="reports-ztg"
                role="tabpanel"
                aria-labelledby="reports-ztg-tab"
              >
                <div className="app-card app-card-orders-table shadow-sm mb-5">
                  <div className="app-card-body">
                    <div
                      className="table-responsive overflow-auto"
                      style={{ maxHeight: 500 }}
                    >
                      <table className="table table-hover table-bordered border-success">
                        <thead
                          style={{
                            position: "sticky",
                            backgroundColor: "#fff",
                            top: 0,
                          }}
                        >
                          <tr>
                            <th scope="col">Type</th>
                            <th scope="col">Date</th>
                            <th scope="col">Link</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.ztgReportData.map(
                            (ztgReportDataRecord, i) => {
                              let formattedZtgDate =
                                ztgReportDataRecord.dateTime !==
                                "0000-00-00 00:00:00"
                                  ? format(
                                      new Date(ztgReportDataRecord.dateTime),
                                      "MMM dd, y h:mm:ss aa"
                                    )
                                  : "No Date Assigned";
                              let ztgreportType = "Zodiac Transformation Guide";
                              let ztgreportLink = `https://csapi.astrologyanswers.com/v1/ztg/create?hash=${this.state.hash}`;

                              return (
                                <tr key={i}>
                                  <td className="fw-bold">{ztgreportType}</td>
                                  <td>{formattedZtgDate}</td>
                                  <td>
                                    <a
                                      href={ztgreportLink}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="link-primary"
                                    >
                                      Download Link
                                    </a>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => this.handleModalShow()}
            >
              Generate Reports
            </button>

            <button
              type="button"
              className="btn btn-primary mx-2"
              onClick={() => this.handleNumerologyModalShow()}
            >
              {this.state.numerologyTitle}
            </button>

            <button
              type="button"
              className="btn btn-primary mx-2"
              onClick={() => this.handleZTGModalShow()}
            >
              {this.state.ztgTitle}
            </button>

            <ReportGenNumerologySection
              numerologyShow={this.state.numerologyShow}
              numerologyTitle={this.state.numerologyTitle}
              numerologyBody={this.state.numerologyBody}
              onClick={this.handleNumerologyModalClose}
              onHide={this.handleNumerologyModalClose}
            />

            <ReportGenZTGSection
              ztgShow={this.state.ztgShow}
              ztgTitle={this.state.ztgTitle}
              ztgBody={this.state.ztgBody}
              onClick={this.handleZTGModalClose}
              onHide={this.handleZTGModalClose}
            />

            <ReportGenSectionModal
              show={this.state.show}
              title={this.state.title}
              body={this.state.body}
              onClick={this.handleModalClose}
              onHide={this.handleModalClose}
            />
          </div>
        </div>
      </div>
    );
  }
}
